(() => {
  function updateLinks(root) {
    root.querySelectorAll('a[href]').forEach(link => {
      let url; try { url = new URL(link.getAttribute('href'), window.location.href); } catch { return; }
      if (url.hostname === 'reneerosebooks.com' || url.hostname === 'www.reneerosebooks.com') {
        link.target = '_blank'; link.rel = [...new Set((link.rel + ' noopener').trim().split(/\s+/))].join(' ');
      }
    });
  }
  updateLinks(document);
  document.addEventListener('shopify:section:load', event => updateLinks(event.target));
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) updateLinks(node.parentElement || node); }))).observe(document.body, {childList:true, subtree:true});
})();